import { Injectable } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { DataService } from '@app/core/services/data.service';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { appSettings } from '@app/core/constants/appSettings';
import { regEx } from '@app/core/constants/regEx';
import { validationMsgs } from '@app/core/constants/validationMsgs';

@Injectable({
    providedIn: 'root'
})
export class JointApplicantReferencesService {

    referenceTypes = this.afs.getRefDataModel();
    subscription = this.afs.subscribeRefDataModel((data: any) => {
        this.referenceTypes = data
    });

    constructor(
        private afs: ApplicationFormService,
        private dataService: DataService,
        private afds: ApplicationFormDataService
    ) {
    }

    yesNoMap = [
        {
            "value": false,
            "name": "No"
        },
        {
            "value": true,
            "name": "Yes"
        }
    ];

    fetchForm(model: any): any {
        return [
            // {
            //     key: 'referenceOneApplicantId',
            // },
            // {
            //     key: 'referenceTwoApplicantId',
            // },
            //Referee 1
            {
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section', title: 'Referee 1' },
                fieldGroup: [
                    {
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-6' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneType',
                                        type: 'select',
                                        props: {
                                            title: 'Type',
                                            required: true,
                                            options: this.dataService.getReferenceDataByName(this.referenceTypes, 'cn_applicationrefereecontacttype')
                                        }
                                    }
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-6' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneSubType',
                                        type: 'select',
                                        props: {
                                            title: 'Individual or organisation?',
                                            required: true,
                                            options: this.dataService.getReferenceDataByName(this.referenceTypes, 'cn_refereecontacttype')
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                expressions: {
                                    hide: (field: FormlyFieldConfig) => !((field.model.referenceOneType === appSettings.refereeContactTypeLandlordPrivate) || (field.model.referenceOneType === appSettings.refereeContactTypeLandlordSocial))
                                },
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-12' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneApplicantAddressId',
                                        type: 'select',
                                        props: {
                                            title: 'Address',
                                            required: true,
                                            options: model.addresses
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        expressions: {
                            hide: (field: FormlyFieldConfig) => !((field.model.referenceOneSubType === appSettings.refereeContactTypeIndividual))
                        },
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-4' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneTitle',
                                        type: 'select',
                                        props: {
                                            title: 'Title',
                                            required: true,
                                            options: this.dataService.getReferenceDataByName(this.referenceTypes, 'cn_titletype')
                                        }
                                    }
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-4' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneFirstName',
                                        type: 'input',
                                        props: {
                                            title: 'First Name',
                                            required: true,
                                            maxLength: 50,
                                            pattern: regEx.namePattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.alphaOnly
                                            }
                                        }
                                    },
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-4' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneLastName',
                                        type: 'input',
                                        props: {
                                            title: 'Last Name',
                                            required: true,
                                            maxLength: 50,
                                            pattern: regEx.namePattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.alphaOnly
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        expressions: {
                            hide: (field: FormlyFieldConfig) => !((field.model.referenceOneSubType === appSettings.refereeContactTypeOrganisation))
                        },
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-12' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneOrganisationName',
                                        type: 'input',
                                        props: {
                                            title: 'Organisation Name',
                                            required: true,
                                            maxLength: 50,
                                            pattern: regEx.alphaNumericPattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.alphaNumeric
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-12' },
                                fieldGroup: [
                                    {
                                        key: 'referenceOneEmail',
                                        type: 'input',
                                        modelOptions: { updateOn: 'blur' },
                                        props: {
                                            title: 'Email Address',
                                            required: true,
                                            maxLength: 100,
                                            pattern: regEx.emailPattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.email
                                            }
                                        }
                                    },
                                    {
                                        key: 'referenceOnePhone',
                                        type: 'input',
                                        props: {
                                            title: 'Phone Number',
                                            required: true,
                                            maxLength: 15,
                                            pattern: regEx.phonePattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.phone
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            //Referee 2
            {
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section', title: 'Referee 2' },
                fieldGroup: [
                    {
                        type: 'help',
                        props: {
                            helpvalue: '<p>Please note this cannot be the same as <b>Referee 1</b>.</p>'
                        }
                    },
                    {
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-6' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoType',
                                        type: 'select',
                                        props: {
                                            title: 'Type',
                                            required: true,
                                            options: this.dataService.getReferenceDataByName(this.referenceTypes, 'cn_applicationrefereecontacttype')
                                        }
                                    }
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-6' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoSubType',
                                        type: 'select',
                                        props: {
                                            title: 'Individual or organisation?',
                                            required: true,
                                            options: this.dataService.getReferenceDataByName(this.referenceTypes, 'cn_refereecontacttype')
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                expressions: {
                                    hide: (field: FormlyFieldConfig) => !((field.model.referenceTwoType === appSettings.refereeContactTypeLandlordPrivate) || (field.model.referenceTwoType === appSettings.refereeContactTypeLandlordSocial))
                                },
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-12' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoApplicantAddressId',
                                        type: 'select',
                                        props: {
                                            title: 'Address',
                                            required: true,
                                            options: (model.addresses as any[]).map(a => { return { name: a.addressLine1 + ' ' + a.addressPostalCode, value: a.addressId } })
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        expressions: {
                            hide: (field: FormlyFieldConfig) => !((field.model.referenceTwoSubType === appSettings.refereeContactTypeIndividual))
                        },
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-4' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoTitle',
                                        type: 'select',
                                        props: {
                                            title: 'Title',
                                            required: true,
                                            options: this.dataService.getReferenceDataByName(this.referenceTypes, 'cn_titletype')
                                        }
                                    }
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-4' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoFirstName',
                                        type: 'input',
                                        props: {
                                            title: 'First Name',
                                            required: true,
                                            maxLength: 50,
                                            pattern: regEx.namePattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.alphaOnly
                                            }
                                        }
                                    },
                                ]
                            },
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-4' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoLastName',
                                        type: 'input',
                                        props: {
                                            title: 'Last Name',
                                            required: true,
                                            maxLength: 50,
                                            pattern: regEx.namePattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.alphaOnly
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        expressions: {
                            hide: (field: FormlyFieldConfig) => !((field.model.referenceTwoSubType === appSettings.refereeContactTypeOrganisation))
                        },
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-12' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoOrganisationName',
                                        type: 'input',
                                        props: {
                                            title: 'Organisation Name',
                                            required: true,
                                            maxLength: 50,
                                            pattern: regEx.alphaNumericPattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.alphaNumeric
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        wrappers: [ 'section' ],
                        props: { htmlClass: 'row' },
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'col-sm-12' },
                                fieldGroup: [
                                    {
                                        key: 'referenceTwoEmail',
                                        type: 'input',
                                        modelOptions: { updateOn: 'blur' },
                                        props: {
                                            title: 'Email Address',
                                            required: true,
                                            maxLength: 100,
                                            pattern: regEx.emailPattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.email
                                            }
                                        }
                                    },
                                    {
                                        key: 'referenceTwoPhone',
                                        type: 'input',
                                        props: {
                                            title: 'Phone Number',
                                            required: true,
                                            maxLength: 15,
                                            pattern: regEx.phonePattern,
                                        },
                                        validation: {
                                            messages: {
                                                pattern: validationMsgs.phone
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }

        ]
    }

    // return {
    //     "type": "object",
    //     "properties": {
    //         "referenceOneType": { "type": "select" },
    //         "referenceOneSubType": { "type": "select" },
    //         "referenceOneTitle": { "type": "select" },
    //         "referenceOneFirstName": { "title": "First Name", "type": "string", "maxLength": 50, "pattern": regEx.namePattern, "validationMessage": { 202: validationMsgs.alphaOnly }  },
    //         "referenceOneLastName": { "title": "Last Name", "type": "string", "maxLength": 50, "pattern": regEx.namePattern, "validationMessage": { 202: validationMsgs.alphaOnly } },
    //         "referenceOneOrganisationName": { "title": "Organisation Name", "type": "string", "maxLength": 50, "pattern": regEx.alphaNumericPattern, "validationMessage": { 202: validationMsgs.alphaNumeric } },
    //         "referenceOneEmail": { "title": "Email Address", "type": "string", "maxLength": 100, "pattern": regEx.emailPattern, "validationMessage": { 202: validationMsgs.email }},
    //         "referenceOnePhone": { "title": "Phone Number", "type": "string", "maxLength": 15, "pattern": regEx.phonePattern, "validationMessage": { 202: validationMsgs.phone } },
    //         "referenceOneApplicantAddressId": { "type": "select" },
    //         "referenceTwoType": { "type": "select" },
    //         "referenceTwoSubType": { "type": "select" },
    //         "referenceTwoTitle": { "type": "select" },
    //         "referenceTwoFirstName": { "title": "First Name", "type": "string", "maxLength": 50, "pattern": regEx.namePattern, "validationMessage": { 202: validationMsgs.alphaOnly } },
    //         "referenceTwoLastName": { "title": "Last Name", "type": "string", "maxLength": 50, "pattern": regEx.namePattern, "validationMessage": { 202: validationMsgs.alphaOnly } },
    //         "referenceTwoOrganisationName": { "title": "Organisation Name", "type": "string", "maxLength": 50, "pattern": regEx.alphaNumericPattern, "validationMessage": { 202: validationMsgs.alphaNumeric }  },
    //         "referenceTwoEmail": { "title": "Email Address", "type": "string", "maxLength": 100, "pattern": regEx.emailPattern, "validationMessage": { 202: validationMsgs.email } },
    //         "referenceTwoPhone": { "title": "Phone Number", "type": "string", "maxLength": 15, "pattern": regEx.phonePattern, "validationMessage": { 202: validationMsgs.phone } },
    //         "referenceTwoApplicantAddressId": { "type": "select" }
    //     },
    //     "required": [
    //         "referenceOneOrganisationName",
    //         "referenceOneFirstName",
    //         "referenceOneLastName",
    //         "referenceOneEmail",
    //         "referenceOnePhone",
    //         "referenceTwoOrganisationName",
    //         "referenceTwoFirstName",
    //         "referenceTwoLastName",
    //         "referenceTwoEmail",
    //         "referenceTwoPhone"
    //     ]
    // };
}
